/**
 * This file contains the extra reducers that will be attached to the fontSelector slice
 * @author Muhammad Shahrukh <shahrukh@250mils.com>
 */
import {getPMWFontsVersion, getUserFacingFonts, getUserUploadedFonts, fetchLanguageScripts} from "./font-selector-thunk.js";
import {alphabeticallySortFonts, setDefaultSelectedFont, setPublicFontsInState} from "@Libraries/font-library.ts";

export const fontSelectorExtraReducers = (builder) => {
    builder.addCase(getPMWFontsVersion.fulfilled, (state, {payload}) => {
        state.pmwFontsVersion = payload.version
    });

    builder.addCase(getUserUploadedFonts.fulfilled, (state, {payload}) => {
        state.userFonts = payload.userFonts.sort(alphabeticallySortFonts);
    });

    builder.addCase(fetchLanguageScripts.fulfilled, (state, {payload}) => {
        state.languageScripts = payload;
    });

    builder.addCase(getUserFacingFonts.fulfilled, (state, {payload}) => {
        setPublicFontsInState(state, payload.pmwTextFonts, payload.fancyTextFonts);
        setDefaultSelectedFont(state, state.pmwFonts);
        state.pmwFontsVersion = payload.version;
    });
}
